module.exports = __webpack_public_path__ + "static/media/61.6ad7b988.gif";